import type { FeatureFlagName } from '@/core/models/feature-flags';
import { useFeatureFlags } from '@/ui/context/feature-flags';

const useFeatureFlag = (flag: FeatureFlagName): boolean => {
  const { isEnabled } = useFeatureFlags();

  return isEnabled(flag);
};

export default useFeatureFlag;
